import type { DashboardDto } from '@tms/shared';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api-client';
import { queryKeys } from '../../lib/query-keys';

export const dashboardQueryOptions = queryOptions({
  queryKey: queryKeys.dashboard,
  queryFn: ({ signal }) => api.get<DashboardDto>('/dashboard', undefined, signal),
});

export const useDashboard = () => useQuery(dashboardQueryOptions);
